export enum UIComponentsTheme {
  White = 'white',
  Grey1 = 'grey-1',
  Grey2 = 'grey-2',
  Dark = 'dark',
}
